var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#D33444"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4884_3378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 5.875C13.3882 5.875 13.7465 6.08008 13.9433 6.41641L19.8496 16.4789C20.0492 16.818 20.0492 17.2363 19.855 17.5754C19.6609 17.9145 19.2972 18.125 18.9062 18.125H7.09372C6.7027 18.125 6.33903 17.9145 6.14489 17.5754C5.95075 17.2363 5.95348 16.8152 6.15036 16.4789L12.0566 6.41641C12.2535 6.08008 12.6117 5.875 13 5.875ZM13 9.375C12.6363 9.375 12.3437 9.66758 12.3437 10.0312V13.0938C12.3437 13.4574 12.6363 13.75 13 13.75C13.3636 13.75 13.6562 13.4574 13.6562 13.0938V10.0312C13.6562 9.66758 13.3636 9.375 13 9.375ZM13.875 15.5C13.875 15.2679 13.7828 15.0454 13.6187 14.8813C13.4546 14.7172 13.232 14.625 13 14.625C12.7679 14.625 12.5453 14.7172 12.3812 14.8813C12.2172 15.0454 12.125 15.2679 12.125 15.5C12.125 15.7321 12.2172 15.9546 12.3812 16.1187C12.5453 16.2828 12.7679 16.375 13 16.375C13.232 16.375 13.4546 16.2828 13.6187 16.1187C13.7828 15.9546 13.875 15.7321 13.875 15.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4884_3378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(6 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2de9f9449b85d548ec26cdc9e401239a.svg";
export { ForwardRef as ReactComponent };